import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DeleteMenuItem } from "components/bootstrap";
import BulkActionsDropdown from "components/common/EntityDataTable/BulkActionsDropdown";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import { ConfirmDialog } from "components/common";
import UserNotification from "util/UserNotification";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { removeWatchlistEntries } from "watchlist/hooks/useWatchlistsV2";
const WatchlistEntriesBulkActions = ({ watchlistId, watchlistName, onRemoved }) => {
  const { selectedEntities, setSelectedEntities } = useSelectedEntities();
  const [showConfirm, setShowConfirm] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const { t } = useTranslation("enterprise_search");
  const handleConfirm = () => {
    removeWatchlistEntries(watchlistId, selectedEntities).then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.WATCHLIST.ENTRIES_DELETED, {
        app_section: "watchlist-details",
        app_action_value: "watchlist-entries-bulk-deleted",
        event_details: { watchlist_name: watchlistName, entry_count: selectedEntities.length }
      });
      UserNotification.success(
        t("watchlist_entries_bulk_actions.removed_entries", { count: selectedEntities.length, watchlistName })
      );
      setSelectedEntities([]);
      onRemoved();
    }).catch(
      (error) => UserNotification.error(t("watchlist_entries_bulk_actions.removing_failed", { error: `${error}` }))
    ).finally(() => setShowConfirm(false));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkActionsDropdown, null, /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: () => setShowConfirm(true) })), showConfirm && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: t("watchlist_entries_bulk_actions.remove_title"),
      show: true,
      onConfirm: handleConfirm,
      onCancel: () => setShowConfirm(false)
    },
    t("watchlist_entries_bulk_actions.confirm_remove", {
      count: selectedEntities.length,
      watchlistName
    })
  ));
};
export default WatchlistEntriesBulkActions;
